export default __webpack_public_path__ + "static/media/jackson.c3c02c3f.png";